import React, { useState, useEffect, useRef } from 'react';
import { Maximize, X } from 'lucide-react';
import logger from '../../utils/logger';

const PanoramicViewer = ({ imageUrl, onClose }) => {
  const containerRef = useRef(null);
  const viewerRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let viewer = null;
    const init = async () => {
      try {
        const { Viewer } = await import('@photo-sphere-viewer/core');
        await import('@photo-sphere-viewer/core/index.css');
        if (containerRef.current) {
          viewer = new Viewer({
            container: containerRef.current,
            panorama: imageUrl,
            navbar: ['zoom', 'fullscreen'],
            defaultZoomLvl: 50,
          });
          viewerRef.current = viewer;
        }
      } catch (err) {
        setError(true);
        logger.error('Panoramic viewer error:', err);
      }
    };
    init();
    return () => { if (viewer) viewer.destroy(); };
  }, [imageUrl]);

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center">
      <button onClick={onClose} className="absolute top-4 right-4 z-10 w-12 h-12 bg-white/20 text-white flex items-center justify-center hover:bg-white/30" data-testid="close-panoramic-btn">
        <X className="h-6 w-6" />
      </button>
      {error ? (
        <div className="text-center text-white p-8">
          <Maximize className="h-16 w-16 mx-auto mb-4 opacity-40" />
          <h3 className="text-xl font-semibold mb-2">360° Image Not Available</h3>
          <p className="text-white/60 text-sm">The panoramic image could not be loaded. The seller needs to upload a valid 360° photo.</p>
          <button onClick={onClose} className="mt-6 px-6 py-2.5 bg-[#E07A3A] text-white font-medium tracking-wider hover:bg-[#C4652E]">CLOSE</button>
        </div>
      ) : (
        <div ref={containerRef} className="w-full h-full" />
      )}
    </div>
  );
};

export default PanoramicViewer;
